import { Injectable } from '@angular/core';
import { ApiService, PagedSearch } from '../../../shared/index';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';

@Injectable()
export class WeeblyService {
  /**
   * inject
   */
  public constructor(private _api: ApiService) {}

  /**
   * check for weebly settings
   * @param search
   */
  public hasWeeblySettings(): Promise<boolean> {
    return this._api.get('Weebly/HasWeebly').then((data: any) => {
      return data;
    });
  }

  public getWeeblySettingBatches(): Promise<Array<string>> {
    return this._api.get('Weebly/BatchSettings').then((data: any) => {
      return data;
    });
  }

  public getWeeblyLoginLink(settingBatch: string): Promise<string> {
    let url = 'Weebly/LoginLink?' + 'settingBatch=' + encodeURI(settingBatch);
    return this._api.get(url).then((data: any) => {
      return data;
    });
  }
}
